import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { NotificationContextProvider } from "./context/NotificationContext";
import { PermissionProvider } from "./context/PermissionContext";
import CustomAlerts from "./components/CustomAlerts";
import AuthTokenBridge from "./api/AuthTokenBridge";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NotificationContextProvider>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email offline_access",
        }}
        useRefreshTokens={true}
        cacheLocation="localstorage"
      >
        <AuthTokenBridge>
          <PermissionProvider>
            <App />
            <CustomAlerts />
          </PermissionProvider>
        </AuthTokenBridge>
      </Auth0Provider>
    </NotificationContextProvider>
  </React.StrictMode>
);

// If you want to measure performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
